import _ from 'lodash';
import moment from 'moment';
import { push } from 'connected-react-router';
import API from '../helpers/api';

export function authorizeWithTicket({ query }) {
	return async dispatch => {
		if (!query || !query.ticket) {
			dispatch(push(`/login?path=${_.get(query, 'path') || ''}`));
			return;
		}
		const res = await API.auth.webCasAuth({ path: query.path, ticket: query.ticket });

		if (res.meta.code !== 200) {
			dispatch(push('/unauthorized'));
			return;
		}

		// store response
		localStorage.setItem('cso_app', JSON.stringify({
			token: res.data.auth.token,
			user: res.data.user,
			last_login: moment()
		}));

		// Navigate to specified page
		if (query.path && query.path !== '/' && query.path !== '') {
			// eslint-disable-next-line no-useless-escape
			const isEncoded = /\%/i.test(query.path);
			if (isEncoded) {
				dispatch(push(decodeURIComponent(query.path)));
				return;
			} else {
				dispatch(push(query.path));
				return;
			}
		}

		// Navigate to next page
		dispatch(push('/'));
	};
}
